import React, { useState } from "react";
import "./Navbar.css";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <a href="#hero" className="navbar-logo">
        <img src="/logo - Kopya.jpeg" alt="KATAR YAPI" />
      </a>
      <button className="navbar-toggle" onClick={toggleMenu} aria-label="Menu">
        <span></span>
        <span></span>
        <span></span>
      </button>
      <ul className={`navbar-links ${isMenuOpen ? "active" : ""}`}>
        <li><a href="#about" onClick={() => setIsMenuOpen(false)}>Hakkımızda</a></li>
        <li><a href="#projects" onClick={() => setIsMenuOpen(false)}>Projeler</a></li>
        <li><a href="#why" onClick={() => setIsMenuOpen(false)}>Neden KATAR YAPI?</a></li>
        <li><a href="#contact" onClick={() => setIsMenuOpen(false)}>İletişim</a></li>
      </ul>
    </nav>
  );
};

export default Navbar; 